// extracted by mini-css-extract-plugin
export default {"formats":"style_formats__XvkzF","button":"style_button__mEF+t","label":"style_label__xnzJJ","error":"style_error__KkavX","upload":"style_upload__lI4wU","image":"style_image__1xeXp"};